var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51733 7.93161C5.23354 7.86631 5.86694 8.39398 5.93224 9.11013L6.10477 11.0026C9.03178 6.4059 14.1128 3.33337 20.0001 3.33337C26.3335 3.33337 31.9149 6.94809 34.6856 12.3733C35.0127 13.0138 34.7587 13.7981 34.1182 14.1252C33.4777 14.4522 32.6935 14.1983 32.3664 13.5578C30.0216 8.96638 25.3128 5.93754 20.0001 5.93754C15.1578 5.93754 10.7879 8.45909 8.28439 12.4094L10.141 11.0834C10.7262 10.6655 11.5394 10.8011 11.9573 11.3862C12.3752 11.9715 12.2397 12.7846 11.6545 13.2026L6.02462 17.2235C5.1995 17.8117 4.06141 17.2732 3.97117 16.2821L3.33895 9.34659C3.27358 8.63038 3.80119 7.99691 4.51733 7.93161Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.882 25.8748C6.5225 25.5478 7.30674 25.8018 7.63382 26.4422C9.97868 31.0336 14.6875 34.0624 20.0002 34.0624C24.8424 34.0624 29.2123 31.5409 31.7158 27.5906L29.8593 28.9165C29.274 29.3344 28.4609 29.1989 28.0429 28.6137C27.625 28.0285 27.7606 27.2154 28.3457 26.7974L33.9756 22.7765C34.7906 22.1942 35.9379 22.7165 36.0291 23.7178L36.6613 30.6534C36.7266 31.3695 36.1989 32.003 35.4828 32.0683C34.7658 32.1335 34.1332 31.6053 34.0679 30.8898L33.8954 28.9973C30.9684 33.5941 25.8875 36.6666 20.0002 36.6666C13.6668 36.6666 8.08532 33.0519 5.31462 27.6266C4.98753 26.9862 5.24157 26.2019 5.882 25.8748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.872b55b3e2c287c59b937d2839f792e5.svg";
export { ForwardRef as ReactComponent };